import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer
      className="relative bg-[#0A0A0A] border-t border-white/10 pt-20 md:pt-28 pb-10 overflow-hidden"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
        {/* Claim */}
        <div className="grid md:grid-cols-12 gap-8 md:gap-12 mb-16 md:mb-24">
          <div className="md:col-span-4">
            <span className="overline !text-[#52525B]">Coda</span>
          </div>
          <div className="md:col-span-8">
            <motion.p
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-5% 0px" }}
              transition={{ duration: 1.1, ease: [0.76, 0, 0.24, 1] }}
              className="font-serif text-[#F4F4F0] italic text-3xl md:text-4xl lg:text-5xl font-light leading-[1.15] tracking-tight max-w-[26ch]"
            >
              &ldquo;{t("footer.claim")}&rdquo;
            </motion.p>
          </div>
        </div>

        {/* Giant brand type */}
        <div className="border-t border-white/10 pt-10">
          <div className="leading-none select-none" aria-hidden>
            <div className="font-serif italic text-[#F4F4F0] font-light tracking-tight text-[22vw] leading-[0.85]">
              Felica
            </div>
            <div className="mt-2 flex flex-wrap items-baseline gap-4 md:gap-8">
              <span className="font-serif text-[#C5A059] font-light tracking-tight text-[14vw] leading-[0.9]">
                Invest
              </span>
              <span className="font-sans text-[#52525B] text-xs md:text-sm tracking-[0.3em] uppercase">
                / Società immobiliare
              </span>
            </div>
          </div>
        </div>

        {/* Bottom row */}
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="font-sans text-xs tracking-[0.2em] uppercase text-[#52525B]">
            {t("footer.rights")}
          </div>
          <div className="flex items-center gap-8">
            <a href="#top" className="nav-link font-sans text-[11px] tracking-[0.24em] uppercase text-[#A1A1AA] hover:text-[#F4F4F0]" data-testid="footer-top">
              ↑ Top
            </a>
            <span className="font-sans text-xs tracking-[0.2em] uppercase text-[#52525B]">
              {t("footer.note")}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};
